import { Option } from '@sapphire/result';
import { BasePayloadMapper, Nullable } from '@ps/utils';
import {
  CompanyDetailFormModel,
  DEFAULT_INVOICE_TYPE,
} from '../../models/company-form.model';
import {
  CompanyDetailPayload,
  CompanyOperatorUser,
} from '../../models/company.model';
import { CompanyNetsuiteFormMapper } from './company-netsuite-form.mapper';

export class CompanyFormPayloadMapper extends BasePayloadMapper<
  CompanyDetailFormModel,
  CompanyDetailPayload
> {
  private readonly _netsuiteMapper = new CompanyNetsuiteFormMapper();

  public constructor(
    private readonly _allOperatorUsers: CompanyOperatorUser[],
  ) {
    super();
  }

  public toPayload(model: CompanyDetailFormModel): CompanyDetailPayload {
    return {
      name: model.name,
      address: model.address,
      phone: model.phone,
      primaryLiaison: model.primaryLiaison,
      secondaryLiaison: model.secondaryLiaison,
      fx: model.fx,
      isABuyer: model.companyType === 'buyer',
      isASupplier: model.companyType === 'supplier',
      isAnOperator: model.companyType === 'operator',
      isFusion: model.companyType === 'fusion',
      isAServiceAccount: model.isAServiceAccount,
      isTestAccount: model.isTestAccount,
      generateInvoice: this._resolveInvoiceType(model),
      accountManagers: this._resolveAccountManagers(model),
      projectManager: this._resolveProjectManager(model),
      orgId: model.orgId,
      suppUrlCompletes: model.suppUrlCompletes,
      suppUrlOverquota: model.suppUrlOverquota,
      suppUrlTerms: model.suppUrlTerms,
      suppUrlSecurityTerms: model.suppUrlSecurityTerms,
      isNotify: model.isNotify,
      isExpose: model.isExpose,
      isAdditionalMetrics: model.isAdditionalMetrics,
      isPureScoreEnable: model.isPureScoreEnable,
      isRdFlagsEnable: model.isRdFlagsEnable,
      appendProfileOnRedirects: model.appendProfileOnRedirects,
      isIncludeBuyerInfoOnStatementReport:
        model.isIncludeBuyerInfoOnStatementReport,
      isManualSupplier: model.isManualSupplier,
      showTrafficChannel: model.showTrafficChannel,
      nsInternalId:
        model.netsuiteEnabled && model.netsuiteInternalId.trim() !== ''
          ? model.netsuiteInternalId
          : null,
      netsuite: this._netsuiteMapper.toNetsuiteDetail(model),
    };
  }

  private _resolveInvoiceType(model: CompanyDetailFormModel): string {
    if (model.companyType === 'buyer' && !model.tempGenerateInvoice) {
      return DEFAULT_INVOICE_TYPE;
    }
    return model.tempGenerateInvoice;
  }

  private _resolveAccountManagers(
    model: CompanyDetailFormModel,
  ): CompanyOperatorUser[] {
    return this._allOperatorUsers.filter((user) =>
      model.accountManagerIds.includes(user.id),
    );
  }

  private _resolveProjectManager(
    model: CompanyDetailFormModel,
  ): Nullable<CompanyOperatorUser> {
    return Option.from(
      this._allOperatorUsers.find((user) => user.id === model.projectManagerId),
    ).unwrapOr(null);
  }
}
